import request from '@/utils/request'
import base from '@/api/base'
const groupApi = {
  queryMyCollegePage: base.api + '/family/mall/new/biCube/queryMyCollegePage', // 查询我的收藏
  cancelCollage: base.api + '/family/mall/new/biCube/cancelCollage', // 取消收藏
  download: base.api + '/family/mall/new/biCube/download', // 下载
  getDownLoadPage: base.api + '/family/mall/new/biCube/queryMyDownLoadPage', // 获取下载页面
  getCollegePage: base.api + '/family/mall/new/biCube/queryMyCollegePage', // 查询我的收藏列表
  getCoordinate: base.api + '/motion/client/project/getCoordinate', // 获取坐标
  addProjectApi: base.api + '/motion/client/project/add', // 添加项目
  addRecycleBin: base.api + '/family/mall/new/biCube/addRecycleBin', // 放入回收站
  getTemplatePage: base.api + '/family/mall/new/biCube/queryMyTemplatePage', // 获取模板页面
  collageApi: base.api + '/family/mall/new/biCube/collage', // 收藏
  getProjectDetail: base.api + '/motion/client/project/detail', // 获取项目详情
  getTemplateDetail: base.api + '/family/mall/new/biCube/queryInfo', // 获取模版详情
  getTemplateDetailById: base.api + '/family/mall/new/biCube/queryById', // 通过主键ID获取模版详情
  cancelPublish: base.api + '/family/mall/new/biCube/cancelPublish', // 取消发布模板（删除）
}
/**
 * 查询我的收藏
 * @returns
 */
export const queryMyCollegePage = (data) => {
  return request({
    url: groupApi.queryMyCollegePage,
    method: 'post',
    data
  })
}
/**
 * 取消收藏
 * @returns
 */
export const cancelCollage = (data) => {
  return request({
    url: groupApi.cancelCollage,
    method: 'post',
    data,
  })
}

// 下载
export function downloadApi(data) {
  return request({
    url: groupApi.download,
    method: 'POST',
    data
  })
}

// 获取下载页面
export const getDownLoadPage = (data) => {
  return request({
    url: groupApi.getDownLoadPage,
    method: 'post',
    data
  })
}

// 我的收藏列表
export const getCollegePage = (data) => {
  return request({
    url: groupApi.getCollegePage,
    method: 'post',
    data
  })
}

// 获取坐标
export const getCoordinate = () => {
  return request({
    url: groupApi.getCoordinate,
    method: 'GET'
  })
}

// 添加项目
export const addProjectApi = (data) => {
  return request({
    url: groupApi.addProjectApi,
    method: 'POST',
    data
  })
}

// 添加回收站
export const addRecycleBin = (data) => {
  return request({
    url: groupApi.addRecycleBin,
    method: 'POST',
    data
  })
}

// 获取模板页面
export const getTemplatePage = (data) => {
  return request({
    url: groupApi.getTemplatePage,
    method: 'POST',
    data
  })
}

// 收藏
export const collageApi = (data) => {
  return request({
    url: groupApi.collageApi,
    method: 'POST',
    data
  })
}

// 获取项目详情
export const getProjectDetail = (data) => {
  return request({
    url: groupApi.getProjectDetail,
    method: 'POST',
    data
  })
}

// 获取模版详情
export const getTemplateDetail = (params) => {
  return request({
    url: groupApi.getTemplateDetail,
    method: 'get',
    params
  })
}
// 获取主键ID获取模版详情
export const getTemplateDetailById = (params) => {
  return request({
    url: groupApi.getTemplateDetailById,
    method: 'get',
    params
  })
}

// 取消发布模板（删除）
export function cancelPublish(data) {
  return request({
    url: groupApi.cancelPublish,
    method: 'POST',
    data
  })
}